// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './Dessert.module.scss';
// =========================

type Props = {
    children: React.ReactNode;
    useAnimations: boolean;
};

const startPositionsX = [-200, -300, -500, -700, -800];
const startPointIndex = Math.floor(Math.random() * 5);

export default function Dessert({ children, useAnimations }: Props) {
    return (
        <div styleName="dessert">
            {children}
            <img
                styleName="top-left"
                alt="dessert"
                src="/images/background-assets/dessert/top-left.svg"
            />
            <img
                styleName="bottom-right"
                alt="dessert"
                src="/images/background-assets/dessert/bottom-right.svg"
            />
            <motion.div
                initial={
                    useAnimations && {
                        x: startPositionsX[startPointIndex],
                        y: -400,
                    }
                }
                animate={
                    useAnimations && {
                        x: 4000,
                        rotate: 660,
                        y: [0, -2000],
                    }
                }
                transition={{
                    // delay: 5,
                    bounce: 1,
                    duration: 28,
                    repeat: Infinity,
                    repeatDelay: 10,
                }}
                styleName="tumbleweed"
            >
                <img
                    alt="tumbleweed"
                    src="/images/background-assets/dessert/tumbleweed.svg"
                />
            </motion.div>
        </div>
    );
}
